export const PensionFunds = {
    LSRA: 'LSR-A',
    LSRB: 'LSR-B',
    LSRSER: 'LSRSER',
    ESUI: 'ESUI',
    LA: 'LA',
    LA_A: 'LA-A',
    LR: 'LR',
};
